import { buildModelManager } from "../builder.js";
const DefaultStripePayoutSelection = {
  __typename: true,
  id: true,
  amount: true,
  arrivalDate: true,
  bankLast4: true,
  bankName: true,
  createdAt: true,
  currency: true,
  failureCode: true,
  failureMessage: true,
  payoutCreatedAt: true,
  payoutId: true,
  profileId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "stripePayout";
const pluralModelApiIdentifier = "stripePayouts";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByPayoutId",
    findByField: "payoutId",
    findByVariableName: "payoutId",
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByPayoutId",
    findByField: "payoutId",
    findByVariableName: "payoutId",
    modelApiIdentifier,
    defaultSelection: DefaultStripePayoutSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "stripePayoutGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const StripePayoutManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultStripePayoutSelection,
  operations
);
export {
  DefaultStripePayoutSelection,
  StripePayoutManager
};
//# sourceMappingURL=StripePayout.js.map
